/**
* Vertical Image Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Vertical Image Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'vertical-image-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.vertical-image-marquee__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          direction: 'ttb',
          autoHeight: true,
          height: $( '.vertical-image-marquee' ).height(),
          gap: '25px',
          drag: false,
          autoScroll: {
            speed: -0.75,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
          arrows: false,
          pagination: false,
          breakpoints: {
            768: {
              direction: 'ltr',
              autoWidth: true,
              gap: '16px',
              height: 'auto',
              autoScroll: {
                speed: 1,
                pauseOnHover: false,
                pauseOnFocus: false,
              },
            },
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'vertical-image-marquee', COMPONENT );
} )( app );
